import BaseView from './BaseView';

import barba from '@barba/core';
import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
import scrollLock from 'scroll-lock';

let view = null;

class ShopIndex extends BaseView {
	constructor(container) {
		super(container);

        if (!'IntersectionObserver' in window) {
            return;
        }
        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
            rootMargin: '-49% 0% -49% 0%',
            treshold: 0
        });

        this.layoutElm = this.container.querySelector('[data-layout-elm]');

        this.collectionName = this.container.querySelector('[data-collection-name]');
        this.organismName = this.container.querySelector('[data-organism-name]');

        this.productCards = this.container.querySelectorAll('[data-product-card]');
        if(this.productCards) {
            this.observeProducts(this.productCards);
        }

        this.isInitialised = false;

        this.breakpoint = window.matchMedia('(min-width:991px)');
        this.breakpoint.addEventListener('change', e => {
            this.checkBreakpoint();
        });
        this.checkBreakpoint();
	}

    checkBreakpoint() {
        if(this.breakpoint.matches) { // Desktop
            scrollLock.disablePageScroll();
        } else { // Mobile
            document.dispatchEvent(new CustomEvent('enable-scroll'));
        }
    }

	init() {
        this.isInitialised = true;

        this.splitOrganismName = new SplitText(this.organismName, {
            type: "words,chars",
            charsClass: "char"
        });

        this.productCards[0].classList.add('is-active');
        this.layoutElm.classList.add('is-animating');

        setTimeout(() => {
            this.layoutElm.classList.add('is-ready');

            gsap.to(this.splitOrganismName.chars, {
                opacity: 1,
                duration: 0,
                stagger: 0.05,
                delay: 0.8
            });

        }, 2400);

	}

    observeProducts(products) {
		products.forEach(product => {
			this.observer.observe(product);
		});
	}

    handleIntersection(entries) {
        entries.forEach(entry => {
			const ratio = entry.intersectionRatio;
			const target = entry.target;
			if (ratio > 0) { // Product is in center of viewport
				this.updateActiveProduct(target);
			}
		});
    }

    updateActiveProduct(product) {
        if(this.activeProduct) {
            this.activeProduct.classList.remove('is-active');
            this.activeProduct.classList.remove('is-clickable');
        }
        this.activeProduct = product;
        this.activeProduct.classList.add('is-active');
        setTimeout(() => { // Delay because index-product transition breaks when the scroll-snap animation is not yet in place..
            this.activeProduct.classList.add('is-clickable');
        }, 1000);

        const collection = product.dataset.collection;
        this.collectionName.innerHTML = collection;

        const organism = product.dataset.organism;
        this.organismName.innerHTML = organism;

        if(!this.isInitialised) {
            this.init();
        }

        const code = product.dataset.code;
        barba.logoLayerDirector.newCode(code);
    }

    destroy() {
		this.observer.disconnect();
	}
}

export default {
	namespace: 'template-shop-index',
	beforeEnter: ({ current, next, trigger }) => {
		view = new ShopIndex(next.container);
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
